import styled from 'styled-components';
import { IconButton } from '@mui/material';
import { theme } from '../../styles/theme';
export const Wrapper = styled(IconButton) `
  && {
    box-shadow: none;
    color: ${theme.colors.textBrand};
    cursor: pointer;

    &.MuiIconButton-colorPrimary {
      background-color: ${theme.colors.buttonBackgroundDefault};
      color: ${theme.colors.buttonTextDefault};

      &:hover {
        background-color: ${theme.colors.buttonBackgroundHover};
        box-shadow: none;
      }

      &:active {
        background-color: ${theme.colors.buttonBackgroundActive};
      }

      &.Mui-disabled {
        background-color: ${theme.colors.buttonBackgroundDisabled};

        &:not(.MuiLoadingButton-loading) {
          color: ${theme.colors.buttonTextDisabled};
        }

        // icon
        svg {
          color: ${theme.colors.buttonTextDisabled};
        }
      }

      // icon
      svg {
        color: ${theme.colors.textInverted};
      }
    }

    &.MuiIconButton-colorSecondary {
      background-color: ${theme.colors.buttonSecondaryBackgroundDefault};
      color: ${theme.colors.buttonTextDefault};

      &:hover {
        background-color: ${theme.colors.buttonSecondaryBackgroundHover};
        box-shadow: none;
      }

      &:active {
        background-color: ${theme.colors.buttonSecondaryBackgroundActive};
      }

      &.Mui-disabled {
        background-color: ${theme.colors.buttonBackgroundDisabled};

        &:not(.MuiLoadingButton-loading) {
          color: ${theme.colors.buttonTextDisabled};
        }

        // icon
        svg {
          color: ${theme.colors.buttonTextDisabled};
        }
      }

      // icon
      svg {
        color: ${theme.colors.buttonTextDefault};
      }
    }
  }
`;
